import { apiRequest } from "@vojomo-core/shared";

export const getMemberData = async (company: string): Promise<any> => {
  const response = await apiRequest({
    subRoute: "operating",
    path: `/get_member_data?company=${company}`
  });

  return response;
};
